/**
 * @generated SignedSource<<b7d0e4bca71eaf68d3979765881c927d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AcceptedTermsAndConditionsHistoryQuery$variables = Record<PropertyKey, never>;
export type AcceptedTermsAndConditionsHistoryQuery$data = {
  readonly acceptedTermsAndConditions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly accepted: boolean;
        readonly acceptedAt: TimeScalar | null | undefined;
        readonly effectiveAt: TimeScalar | null | undefined;
        readonly id: string;
        readonly source: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
        readonly version: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type AcceptedTermsAndConditionsHistoryQuery = {
  response: AcceptedTermsAndConditionsHistoryQuery$data;
  variables: AcceptedTermsAndConditionsHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TermsAndConditionsConnection",
    "kind": "LinkedField",
    "name": "acceptedTermsAndConditions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TermsAndConditionsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TermsAndConditions",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "source",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accepted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "acceptedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "effectiveAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptedTermsAndConditionsHistoryQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AcceptedTermsAndConditionsHistoryQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "5cbcef1b98f70b521e27b0fe24e0f588",
    "id": null,
    "metadata": {},
    "name": "AcceptedTermsAndConditionsHistoryQuery",
    "operationKind": "query",
    "text": "query AcceptedTermsAndConditionsHistoryQuery {\n  acceptedTermsAndConditions {\n    edges {\n      node {\n        id\n        type\n        title\n        version\n        source\n        accepted\n        acceptedAt\n        effectiveAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cdc727e3312b458448173cece2c22d2d";

export default node;
